import React from "react";
import { useNavigate } from "react-router-dom";
import "./scss/back-button.scss";

export default function BackButton({ to = -1, label = "Назад" }) {
  const navigate = useNavigate();

  return (
    <div className="back-button" onClick={() => navigate(to)}>
      <span className="back-button__icon">‹</span>
      <span className="back-button__text">{label}</span>
    </div>
  );
}
